module.exports = __webpack_public_path__ + "static/media/columbia-global-centers-amman.6e3523e4.png";